var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',[_c('feather-icon',{staticClass:"success",attrs:{"size":"21","icon":"BatteryIcon"}}),_c('span',{staticStyle:{"padding-left":"5px","font-size":"9pt"}},[_vm._v("1.5k")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }